export default class PORSiteToSiteStandardConfiguration {

	option!: number;

    ph1DHGroup!: string;

	ph1EncrypAlgo!: string;

	ph1TimeoutSec!: string;

	ph1PRFAlgo!: string;

	ph1IKE!: string;

	ph2DHGroup!: string;

	ph2ESPEncryp!: string;

	ph2TimeoutKb!: string;

	ph2TimeoutSec!: string;

	ph2Authentication!: string;

	ph2EnablePFS!: string;

    constructor(config: PORSiteToSiteStandardConfiguration) {
        Object.assign(this, config);
    }
}